(() => {
  // Funnel events queue in the dataLayer; GTM only reads them after the visitor accepts tracking.
  const track = (event, data = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...data });
  };
  window.funnelTrack = track;

  // Keep the ad's UTM tags on funnel CTAs so the product page visit stays attributed to the right funnel.
  const carried = Array.from(new URLSearchParams(window.location.search)).filter(([key]) => key.startsWith('utm_'));
  const withUtms = (href) => {
    const url = new URL(href, window.location.origin);
    if (url.origin !== window.location.origin) return href;
    carried.forEach(([key, value]) => { if (!url.searchParams.has(key)) url.searchParams.set(key, value); });
    return url.pathname + url.search + url.hash;
  };
  window.funnelLink = withUtms;

  const init = (root) => {
    if (root.dataset.funnelReady) return;
    root.dataset.funnelReady = 'true';
    const funnel = root.dataset.funnel;
    track('funnel_view', { funnel });

    root.querySelectorAll('a[data-funnel-cta]').forEach((link) => { link.href = withUtms(link.getAttribute('href')); });
    root.addEventListener('click', (event) => {
      const link = event.target.closest('[data-funnel-cta]');
      if (link) track('funnel_cta_click', { funnel, cta: link.dataset.funnelCta });
    });

    const depths = [50, 90];
    const onScroll = () => {
      const box = root.getBoundingClientRect();
      const seen = Math.min(100, ((window.innerHeight - box.top) / box.height) * 100);
      while (depths.length && seen >= depths[0]) track('funnel_scroll', { funnel, depth: depths.shift() });
      if (!depths.length) window.removeEventListener('scroll', onScroll);
    };
    window.addEventListener('scroll', onScroll, { passive: true });

    // The sticky bar appears once the reader is past the opening, and hides while an offer box is on screen.
    const sticky = root.querySelector('[data-funnel-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      const visible = new Set();
      const start = root.querySelector('[data-funnel-start]');
      let pastStart = false;
      const sync = () => { sticky.classList.toggle('is-visible', pastStart && visible.size === 0); };
      const offers = new IntersectionObserver((entries) => {
        entries.forEach((entry) => { entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target); });
        sync();
      });
      root.querySelectorAll('[data-funnel-offer]').forEach((offer) => offers.observe(offer));
      if (start) new IntersectionObserver(([entry]) => {
        pastStart = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sync();
      }).observe(start);
    }
  };

  // Offer box buy forms: match the chosen colour and size to a variant. theme.js does the actual add to cart.
  const initBuy = (form) => {
    if (form.dataset.buyReady) return;
    form.dataset.buyReady = 'true';
    const variants = JSON.parse(form.querySelector('[data-funnel-variants]').textContent);
    const strings = JSON.parse(form.querySelector('[data-funnel-buy-strings]').textContent);
    const fields = Array.from(form.querySelectorAll('[data-variant-picker] fieldset'));
    const idInput = form.querySelector('[data-funnel-variant]');
    const button = form.querySelector('[data-funnel-add]');
    const sync = () => {
      const selected = fields.map((field) => field.querySelector('input:checked')?.value);
      fields.forEach((field, index) => {
        const label = field.querySelector('[data-selected-value]');
        if (label && selected[index] !== undefined) label.textContent = selected[index];
      });
      const variant = selected.includes(undefined) ? null : variants.find((item) => item.options.every((value, index) => value === selected[index]));
      idInput.value = variant?.available ? variant.id : '';
      button.disabled = !variant?.available;
      button.textContent = !variant ? strings.choose : variant.available ? strings.add : strings.soldOut;
    };
    form.addEventListener('change', (event) => { if (event.target.closest('[data-variant-picker]')) sync(); });
    form.addEventListener('submit', (event) => {
      if (!idInput.value) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      track('funnel_add_to_cart', { funnel: form.closest('[data-funnel]')?.dataset.funnel, cta: form.dataset.funnelBuyId, variant_id: Number(idInput.value) });
    }, true);
    form.funnelSelectSize = (size) => {
      const field = fields.find((item) => /size|specification/i.test(item.dataset.optionName || ''));
      const input = field && Array.from(field.querySelectorAll('input')).find((item) => item.value.trim().toUpperCase() === size);
      if (!input) return;
      input.checked = true;
      sync();
    };
    sync();
  };

  const scan = (scope) => {
    scope.querySelectorAll('[data-funnel]').forEach(init);
    scope.querySelectorAll('[data-funnel-buy]').forEach(initBuy);
  };
  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
